import { ChannelPayloadFilter, ViewStream } from "spyne";
import { CodeContainerExamplesHolder } from "./code-container-examples-holder";
import { CodeContainerDetailsText } from "./code-container-details-text";
import { CodeContainerExamplesLink } from "components/code-examples/code-container-examples-link";
import { ExternalEventsTraits } from "traits/external-events-traits";

export class CodeContainerDetails extends ViewStream {
  constructor(props = {}) {
    //props.id = "code-container-details";
    props.class = `code-section code-container-details code-container-details-${props.pageId}`;
    props.traits = [ExternalEventsTraits];
    props.template = require("./templates/code-container-details.tmpl.html");
    //console.log("CODE CONTAINER details ", props);
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const { parentVsid, codeBlockId } = this.props;
    //console.log("THIS DETAILS VSID ",parentVsid);
    const isContainerFilter = new ChannelPayloadFilter({
      payload: (v) => v.parentVsid === parentVsid,
    });
    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_STYLE_UPDATE_EVENT",
        "onCodeStyleUpdate",
        isContainerFilter,
      ],
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onChannelCodeUpdate",
        isCodeBlockIdFilter,
      ],
      ["CHANNEL_CODE_GEN_DATA.*_EVENT", "onCodeLoaded", isContainerFilter],
    ];
  }

  onCodeStyleUpdate(e) {
    const { styleType, styleKey, styleVal, iframeHeight } = e.payload;

    if (styleType === "height") {
      this.props.el.style[styleKey] = styleVal;
      this.props.iframeHeight = iframeHeight;
    }
  }

  onCodeLoaded(e) {
    const { action, payload } = e;
    this.props.codePayload = payload;
    //console.log("CODE IN DETAIL LOADED ",{action, payload}, this.props.data?.externalEvents);

    if (this.props?.data?.externalEvents !== undefined) {
      this.externalEvent$CheckToAddExtBtnsToPlaygroundHeader(
        this.props.codePayload,
        this.props.data,
      );
    }

    // this.externalEvent$CheckToAddExtBtnsToPlaygroundHeader(payload);
  }

  onChannelCodeUpdate(e) {
    //console.log("ON CHANNEL CODE UPDATE ",e);

    if (this === undefined || this.props === undefined) {
      return;
    }

    const data = e.payload;
    const { parentVsid, codeBlockId, pageId, iframeHeight } = this.props;
    const hasLink = data.info.link !== undefined;
    this.props.data = data;

    if (this.props.codePayload && data.externalEvents !== undefined) {
      // this.externalEvent$CheckToAddExtBtnsToPlaygroundHeader(this.props.codePayload, data);
    }

    //console.log("DETAILS UPDATE ",{data, parentVsid})

    if (hasLink === true) {
      //  this.appendView(new CodeContainerExamplesLink({data,parentVsid, codeBlockId}))
    }

    this.appendView(
      new CodeContainerExamplesHolder({
        data,
        parentVsid,
        codeBlockId,
        iframeHeight,
      }),
      ".details-example-holder",
    );

    if (pageId !== "reference") {
      this.prependViewToParentEl(
        new CodeContainerDetailsText({ data, parentVsid, codeBlockId }),
        ".code-container-content-holder",
      );
    }
    //console.log('channel code updated ',e);
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    //this.appendView(new CodeContainerExamplesHolder())
    this.addChannel("CHANNEL_CODE_CONTAINER");
    this.addChannel("CHANNEL_CODE_GEN");

    // this.appendView(new ViewStream({tagName: 'h2', 'data': 'testing'}), ".details-example-holder");
  }
}
